export const formatPincode = (value: string) => {
  return value.replace(/(\d{3})(\d{3})/, "$1 $2");
};